import { dopplerLensAbi } from './chunk-OAUUC2IW.mjs';
import { createDrift } from '@delvtech/drift';

var ReadDopplerLens = class {
  constructor(address, drift = createDrift()) {
    this.dopplerLensAddress = address;
    this.dopplerLens = drift.contract({
      abi: dopplerLensAbi,
      address
    });
    this.drift = drift;
  }
  async poolManager() {
    return this.dopplerLens.read("poolManager");
  }
  async stateView() {
    return this.dopplerLens.read("stateView");
  }
  async quoteDopplerLensData(params) {
    return this.dopplerLens.simulateWrite("quoteDopplerLensData", { params });
  }
};

export { ReadDopplerLens };
//# sourceMappingURL=chunk-RMIAHRZ2.mjs.map
//# sourceMappingURL=chunk-RMIAHRZ2.mjs.map